<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="export()"
                  particleAnalytics
                  analyticsCategory="dac6-hallmark-countries"
                  analyticsAction="export"
          >Export
          </button>
        </div>
      </div>
    </div>
  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="hallmark-countries" class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->


        <div class="content  pos-relative flex flex-col full-grow-no-shrink-no-basis">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceType"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
            >
            </particle-virtual-grid>
          </div>
        </div>


      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
